import { defineComponent as _defineComponent } from 'vue';
import { computed, ref, watch } from "vue";
import { useSelectableObjectStores } from "@/composables/useObjectStores";
import {} from "@/utils/filtering";
import FilterObjectStoreLink from "./FilterObjectStoreLink.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterMenuObjectStore',
    props: {
        name: null,
        filter: null,
        filters: null
    },
    emits: ["change"],
    setup(__props, { emit }) {
        const props = __props;
        const propValue = computed(() => props.filters[props.name]);
        const localValue = ref(propValue.value);
        watch(() => localValue.value, (newFilter) => {
            emit("change", props.name, newFilter);
        });
        watch(() => propValue.value, (newFilter) => {
            localValue.value = newFilter;
        });
        const { selectableObjectStores, hasSelectableObjectStores } = useSelectableObjectStores();
        function onChange(value) {
            localValue.value = (value || undefined);
        }
        return { __sfc: true, props, emit, propValue, localValue, selectableObjectStores, hasSelectableObjectStores, onChange, FilterObjectStoreLink };
    }
});
